// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"773":"cac3387d","6551":"cfc1c3a6","7937":"c79bcc14","9988":"a8e37c63"}[chunkId] + ".chunk.css");